<template>
  <div class="container-fuluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-7">
        <h5>ナースコールから通話へ振り替え</h5>
        通話履歴登録時のdisplayNameと下記キーワードが一致する場合、通常の電話に振り分けられる様になります
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-4">
        <table class="table table-sm table-hover form-table table-striped table-bordered">
          <thead>
            <tr>
              <th scope="col" style="width:80px"></th>
              <th scope="col">キーワード</th>
            </tr>
          </thead>
          <tbody>
              <tr v-for="(setting, index) in settings" v-bind:key="index">
                <td>
                  <button type="button" class="btn-sm" v-on:click="remove(index)">
                    <img class="times-solid" src="/times-solid.svg">
                  </button>
                </td>
                <td>{{ setting }}</td>
              </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col-8">
            <input type="text" maxlength="32" v-model="setting" class="form-control" autocomplete="off" placeholder="キーワード">
          </div>
          <div class="col-4">
            <button class="btn-sm btn-outline-info" type="submit" v-on:click="add()">追加する</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
        <div class="col-1">
        </div>
        <div class="col-4">
            <button id="register_button" class="btn btn-info btn btn-block" v-on:click="register()">更新する</button>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Index',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function () {
    return {
      settings: [],
      setting: '',
      message: ''
    }
  },
  mounted() {
    if(this.$store.getters.hospital.id !==0){
      this.init()
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.init()
        }
      }
    )
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    }
  },
  methods: {
    init() {
      this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var hospitalId = this.$store.getters.hospital.id
        axios
          .get("/api/setting/" + hospitalId, {
            headers: this.headers(accessToken)
          })
          .then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            }
            this.settings = res.data.settings ? res.data.settings : []
          })
          .catch(err => {
            this.message = err.message
          })
      } else {
        this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
      }
    }).catch(err => {
      this.message = err.message
    })
    },
    remove(index) {
      this.settings.splice(index,1)
    },
    add() {
      this.settings.push(this.setting)
      this.setting = ''
    },
    register() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          axios
            .put("/api/setting/" + hospitalId, {
              settings: this.settings
            },{
              headers: this.headers(accessToken)
            })
            .then(response => {
              var res = response.data;
              if(res.errorMessage) {
                this.message = res.errorMessage
              } else {
                this.message = ''
                alert('更新されました。')
              }
            })
            .catch(err => {
              this.message = err.message
            })
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
        }
      }).catch(err => {
        this.message = err.message
      })
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
#register_button {
  margin-top: 30px;
}
.btn-sm{
  margin-left: 5px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.times-solid{
  cursor: pointer;
  height: 15px;
  width: 15px;
}
</style>